export interface CompletedNursingAssessmentEditContext {
  isNurse: boolean;
  currentNurseId: unknown;
  assessmentNurse: unknown;
  approvalStatus: unknown;
}

function matchKey(value: unknown): string {
  return String(value ?? '').trim().replace(/[^a-z0-9]/gi, '').toLowerCase();
}

export function nursingAssessmentReferenceId(value: unknown): string {
  if (typeof value === 'string') return value.trim();
  if (!value || typeof value !== 'object' || Array.isArray(value)) return '';
  const record = value as Record<string, unknown>;
  return String(record.id || record.nexusId || record.Id || record.value || '').trim();
}

export function isEditableNursingAssessmentApprovalStatus(value: unknown): boolean {
  const normalized = matchKey(value);
  return normalized === '' || normalized === matchKey('Revision Needed');
}

export function isAuthorizedNurseForCompletedNursingAssessment(
  context: Omit<CompletedNursingAssessmentEditContext, 'approvalStatus'>
): boolean {
  if (!context.isNurse) return false;
  const currentNurseId = nursingAssessmentReferenceId(context.currentNurseId);
  const assessmentNurseId = nursingAssessmentReferenceId(context.assessmentNurse);
  return Boolean(currentNurseId) && currentNurseId === assessmentNurseId;
}

export function canEditCompletedNursingAssessment(
  context: CompletedNursingAssessmentEditContext
): boolean {
  return isAuthorizedNurseForCompletedNursingAssessment(context)
    && isEditableNursingAssessmentApprovalStatus(context.approvalStatus);
}
